import React, { createContext, useContext, useRef, useEffect, useState } from "react";

// Lets a page override what the shared PageHeader's back button does (e.g. step out
// of a local sub-view like an archive/detail screen) instead of always navigate(-1).
const BackHandlerContext = createContext({ handler: null, setHandler: () => {} });

export function BackHandlerProvider({ children }) {
  const [handler, setHandler] = useState(null);
  return (
    <BackHandlerContext.Provider value={{ handler, setHandler }}>
      {children}
    </BackHandlerContext.Provider>
  );
}

export function useBackHandler() {
  return useContext(BackHandlerContext);
}

// Call from a page with its "go back one step" logic. Registers once on mount and
// always calls the latest version of `handler` (via ref) - no need to memoize it.
export function useRegisterBackHandler(handler) {
  const { setHandler } = useContext(BackHandlerContext);
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    // Double-wrapped: useState's setter calls a function argument as an updater, so
    // the outer arrow is that updater and the inner arrow is the value actually stored.
    setHandler(() => () => handlerRef.current());
    return () => setHandler(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
